import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: 'age-gender-dialog',
    template: `
    <h2 mat-dialog-title>{{data?.title}}</h2>
    <mat-dialog-content class="mat-typography">
        <label class="margin-l-r-10"><b>Values from region:</b></label>
        <div [style.height]="height">
            <app-age-gender-distribution #ageGenderDistributionComparerChild [data]="data.ageGenderCompareMatrix" [form]="_formComparer" [isSumDisplayed]="data.isCompareMatrixSumDisplayed" [isEditable]="data.isCompareMatrixEditable"></app-age-gender-distribution>
        </div>
        <label class="margin-l-r-10"><b>Editor:</b></label>
        <div [style.height]="height">
            <app-age-gender-distribution #ageGenderDistributionChild [data]="data.ageGender" (validationCheckOutput)="checkValidation($event)" [form]="_form" [isSumDisplayed]="data.isSumDisplayed" [isEditable]="data.isEditable"></app-age-gender-distribution>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button class="color" mat-button mat-dialog-close *ngIf="data.showCancel">{{data.cancelButtonText}}</button>
        <span class="spacer"></span>
        <button class="color" mat-button (click)="save()" [disabled]="!validationCheck">{{data.saveButtonText}}</button>
    </mat-dialog-actions>
    `
})
export class AgeGenderCompareDialog {
    _form: FormGroup;
    _formComparer: FormGroup;
    validationCheck: boolean = false;
    @ViewChild('ageGenderDistributionChild', { static: false }) ageGenderDistributionChild;
    @ViewChild('ageGenderDistributionChild', { static: false }) ageGenderDistributionComparerChild;
    height: string;

    constructor(@Inject(MAT_DIALOG_DATA) public data, private fb: FormBuilder, public dialogRef: MatDialogRef<AgeGenderCompareDialog>) {
        dialogRef.disableClose = true;
        this._form = this.fb.group({});
        this._formComparer = this.fb.group({});
        this.height = data.height;
        this.dialogRef.disableClose = true;
    }

    save() {
        this.ageGenderDistributionChild.save();
        this.dialogRef.close({ result: true, data: this._form.getRawValue() });
    }
    checkValidation(validation: boolean) {
        this.validationCheck = validation;
    }
}